export const injectedJavaScript = `
    window.addEventListener('popstate', function(event) {
      console.log("Popstate called!!!");
      window.ReactNativeWebView.postMessage(JSON.stringify({ event: 'popstate' }));
    });
  `;
